<template>
<!-- 新增围栏 -->
  <div>
    <el-dialog
      :title="title"
      :visible.sync="mapDialogVisible"
      width="1200px"
      :before-close="handleClose"
      v-if="mapDialogVisible"
      :close-on-click-modal="false"
    >
      <div class="module-content">
        <div id="addmap">
          <Map
            @getFencePaths="getFencePaths"
            @setCity="setCity"
            :cenetrLanLng="cenetrLanLng"
            :paths="paths"
            :openMap="openMap"
          />
        </div>
        <div class="map-from">
          <div class="from-title">{{ title }}</div>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="auto"
            class="demo-ruleForm"
          >
            <el-form-item :label="$t('pages.operate.text79')">
              <div>{{ city }}</div>
            </el-form-item>
            <el-form-item :label="$t('pages.operate.text71')" prop="geoName">
              <el-input v-model="ruleForm.geoName"></el-input>
            </el-form-item>
            <el-form-item :label="$t('pages.operate.text72')" prop="status">
              <el-radio-group v-model="ruleForm.status">
                <el-radio :label="0">{{$t('pages.operate.text73')}}</el-radio>
                <el-radio :label="1">{{$t('pages.operate.text74')}}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('pages.operate.text80')" prop="speedLimit">
              <el-input-number
                v-model="ruleForm.speedLimit"
                controls-position="right"
                :min="1"
                :max="25"
              ></el-input-number>
              <span style="margin-left: 12px">km/h</span>
            </el-form-item>
          </el-form>
          <div class="from-tips">
            <span>{{$t('pages.operate.text81')}}:</span>
            <span>1.{{$t('pages.operate.text82')}}</span>
            <span>2.{{$t('pages.operate.text83')}}</span>
            <span>3.{{$t('pages.operate.text84')}}</span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{$t('button.cancel')}}</el-button>
        <el-button type="primary" @click="submit">{{$t('button.determine')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
import Map from "./map.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      openMap: false,
      title: this.$t('pages.operate.text76'),
      ruleForm: {
        centerLat: "", //中心点纬度
        centerLon: "", //中心点经度
        geoName: "", //电子围栏名称
        geoPoint: [], //电子围栏集合
        speedLimit: 1, //速度上限
        status: 0, //状态（0：有效，1：无效）
      },
      cenetrLanLng: { lat: 51.51108087472238, lng: -0.12420020719467573 },
      paths: [],
      city: "",
      rules: {
        geoName: [
          { required: true, message: this.$t('pages.operate.text87'), trigger: "blur" },
          {
            min: 1,
            max: 32,
            message: this.$t('pages.operate.text90'),
            trigger: "blur",
          },
        ],
        speedLimit: [
          { required: true, message: this.$t('pages.operate.text88'), trigger: "blur" },
        ],
        status: [
          { required: true, message: this.$t('pages.operate.text89'), trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapState(["platformData", "regionList", "currentRegion"]),
  },
  components: {
    Map,
  },
  watch: {
    mapDialogVisible(newValue) {
      this.openMap = true;
      if (newValue) {
        if (this.pageType == 0) {
          this.title = this.$t('pages.operate.text76');
        } else {
          this.title = this.$t('pages.operate.text77');
          this.ruleForm.id = this.currentFence.id;
          this.ruleForm.centerLat = this.currentFence.centerLat;
          this.ruleForm.centerLon = this.currentFence.centerLon;
          this.ruleForm.geoName = this.currentFence.geoName;
          this.ruleForm.geoPoint = JSON.parse(this.currentFence.geoPoint);
          this.ruleForm.speedLimit = this.currentFence.speedLimit;
          this.ruleForm.status = this.currentFence.status;
          this.cenetrLanLng = {
            lat: this.currentFence.centerLat,
            lng: this.currentFence.centerLon,
          };
          this.paths = JSON.parse(this.currentFence.geoPoint);
        }
      }
    },
  },
  props: ["mapDialogVisible", "pageType", "currentFence"],
  methods: {
    //取消
    handleClose() {
      this.ruleForm = {
        centerLat: "", //中心点纬度
        centerLon: "", //中心点经度
        geoName: "", //电子围栏名称
        geoPoint: [], //电子围栏集合
        speedLimit: 1, //速度上限
        status: 0, //状态（0：有效，1：无效）
      };
      this.openMap = false;
      this.cenetrLanLng = { lat: 51.51108087472238, lng: -0.12420020719467573 };
      this.paths = [];
      this.city = "";
      this.$emit("mapdialogVisibleCloe");
    },
    getFencePaths(e) {
      let arr = this.regionList;
      if (arr[this.currentRegion].id != "cn") {
        let arr = e.paths.map((i) => {
          return { lat: i.lat(), lng: i.lng() };
        });
        this.ruleForm.centerLat = e.center.lat;
        this.ruleForm.centerLon = e.center.lng;
        this.ruleForm.geoPoint = arr;
      } else {
        let arr = e.paths.map((i) => {
          return { lat: i.lat, lng: i.lng };
        });
        this.ruleForm.centerLat = e.center.lat;
        this.ruleForm.centerLon = e.center.lng;
        this.ruleForm.geoPoint = arr;
      }
    },
    //设置城市
    setCity(e) {
      this.city = e;
    },
    //确定
    submit() {
      let that = this;
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (!this.ruleForm.centerLon && !this.ruleForm.centerLat) {
            return this.$message.error(
              that.$t('pages.operate.text91')
            );
          }
          if (this.ruleForm.geoPoint.length < 1) {
            return this.$message.error(that.$t('pages.operate.text92'));
          }
          this.ruleForm.belongCustomerId = this.platformData.id;
          if (this.pageType == 0) {
            this.request.geoAddFence(this.ruleForm).then(() => {
              this.$emit("geoList");
              this.$message.success(that.$t('pages.operate.text93'));
              this.handleClose();
            }).catch((err)=>{
              this.$message.error(err.msg);
            });
          } else {
            this.request.geoEditFence(this.ruleForm).then(() => {
              this.$emit("geoList");
              this.$message.success(that.$t('pages.operate.text94'));
              this.handleClose();
            }).catch((err)=>{
              this.$message.error(err.msg);
            });
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.module-content {
  display: flex;
}
#addmap {
  width: 700px;
  height: 550px;
  margin-right: 20px;
}
.map-from {
  flex: 1;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.from-title {
  text-align: center;
  margin: 70px 0;
  margin-bottom: 40px;
  font-size: 16px;
  font-family: Caros;
  font-weight: 500;
  line-height: 0px;
  color: #000000;
}
.from-tips {
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
}
.demo-ruleForm {
  padding: 0 35px;
  box-sizing: border-box;
}
</style>